module.exports = __webpack_public_path__ + "static/media/methamphetamineActive.825c79c3.svg";